import moment from 'moment';

export default function (value: string, alt?: string): string {
	if (!value) return (alt || '');

	moment.locale();

	const num  = +value;
	const date = isNaN(num)
		? moment(value).calendar()
		: moment.unix(num).calendar();

	return date;
}
